import { render, staticRenderFns } from "./KiteDoc.vue?vue&type=template&id=a289f0b4&scoped=true"
import script from "./KiteDoc.vue?vue&type=script&lang=js"
export * from "./KiteDoc.vue?vue&type=script&lang=js"
import style0 from "./KiteDoc.vue?vue&type=style&index=0&id=a289f0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.aspect_rules_js/vue-loader@15.11.1_200321279/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a289f0b4",
  null
  
)

export default component.exports